import { Stat } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function StatDemo() {
  return (
    <Section
      id="stat"
      title="Stat"
      description="KPI / metric card. Renderer for the K2 `stat` block - props are the streamed `{ label, value, delta?, unit? }`."
    >
      <VariantBlock label="With deltas">
        <Stat label="Monthly revenue" value={42300} unit="$" delta={12.4} />
        <Stat label="Active studios" value={1287} delta={-3.1} />
        <Stat label="Uptime" value={99.98} unit="%" delta={{ value: 0, label: "flat" }} />
      </VariantBlock>

      <VariantBlock label="Inverted (up = bad)" caption="latency / error-rate style">
        <Stat label="p95 latency" value={214} unit="ms" delta={{ value: 8.2, upIsGood: false }} />
        <Stat label="Error rate" value={0.4} unit="%" delta={{ value: -1.1, upIsGood: false }} />
      </VariantBlock>

      <VariantBlock label="Sizes">
        <Stat size="sm" label="Small" value={12} unit="k" />
        <Stat size="default" label="Default" value={3400} delta={5} />
        <Stat size="lg" label="Large" value={88} unit="%" delta={2} />
      </VariantBlock>

      <VariantBlock label="String value + states">
        <Stat label="Plan" value="Enterprise" />
        <Stat label="Loading" value={0} loading />
        <Stat label="Revenue" value={0} error="Metrics feed is down." />
      </VariantBlock>
    </Section>
  );
}
